import styled from 'styled-components';

export const DropdownWrapper = styled('div')`
  margin-left: -11px;
`;

export const ButtonWrapper = styled('div')<{ active?: boolean }>`
  display: inline-block;
  background: ${({ theme, active }) => active && theme.color.whiteRGBA(0.05)};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
`;

export const TotalRecords = styled('span')`
  ${({ theme }) => theme.typography.tiny};
  color: ${({ theme }) => theme.color.whiteRGBA(0.3)};
`;
